var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.165 7.36v11.6l-1.12.24q-1.44.32-3.12.56-2.32.24-4.8.24t-4.8-.24q-1.68-.24-3.12-.56l-1.04-.24V7.36L9.125 0zm-9.04-4.8-6.96 5.76v9.04l.72.16q1.04.16 2.24.32v-6.88h8v6.88q1.2-.16 2.24-.32l.8-.16V8.32zm-2 15.36q2 .16 4 0v-4.96h-4z"
  })));
};
export default SvgHome;